interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-600">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
          )}
          {item.href ? (
            <a
              href={item.href}
              className="hover:text-primary-500 transition-colors duration-200"
            >
              {item.label}
            </a>
          ) : (
            <span className="text-foreground-900 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export function getCategoryBreadcrumb(categoryName: string, categorySlug: string): BreadcrumbItem[] {
  return [
    { label: '首页', href: '/' },
    { label: categoryName, href: `/category/${categorySlug}` },
  ];
}

export function getArticleBreadcrumb(
  categoryName: string,
  categorySlug: string,
  articleTitle: string,
): BreadcrumbItem[] {
  return [
    { label: '首页', href: '/' },
    { label: categoryName, href: `/category/${categorySlug}` },
    { label: articleTitle },
  ];
}